import { clientInfo } from "../resources";

const ms = {
    general: {
        desc: "Percuma",
        desc2: "Penstriman Langsung Sukan",
        desc3: "di Telefon Anda!",
        download: "MUAT TURUN APLIKASI",
        availableDevice: "Hanya tersedia untuk Android",
        copyRight: `© ${clientInfo.brand}. Semua hak cipta terpelihara.`,
        downloadTitle: "Muat Turun APK",
        downloadText: "Pautan muat turun"
    },
    step: {
        title: "Cara memuat turun dan memasang",
        step_1: "LANGKAH 1",
        step_1_desc: `Nyahpasang versi lama ${clientInfo.brand} jika masih ada di telefon anda`,
        step_2: "LANGKAH 2",
        step_2_btn: "Muat Turun",
        step_2_desc: `Fail APK ${clientInfo.brand} yang baharu`,
        step2_dl_collapse: {
            title: "Pautan muat turun APK",
            dl_1: "Pautan muat turun"
        },
        step_3: "LANGKAH 3",
        step_3_desc: `Tekan <b>Muat turun juga</b> untuk meneruskan`,
        step_4: "LANGKAH 4 <b>Situasi Tertentu</b>",
        step_4_desc: "Tukar tetapan keselamatan untuk membenarkan telefon anda memasang aplikasi daripada sumber lain",
        step_5: "LANGKAH 5 <b>Situasi Tertentu</b>",
        step_5_desc: "Jika anda menggunakan Chrome sebagai pelayar lalai, hidupkan suis <b>Chrome</b> untuk teruskan",
        step_5_desc_1: "Jika anda telah memuat turun APK, hidupkan suis <b>Fail Saya</b> sebagai ganti",
        step_6: "LANGKAH 6",
        step_6_desc: ` Tekan <b>Pasang</b> untuk mula memasang aplikasi ${clientInfo.brand} yang baharu`,
        step_7: "LANGKAH 7",
        step_7_desc: `Semuanya siap! Buka aplikasi ${clientInfo.brand} dan nikmati!`
    },
    ads_form: {
        dialog: {
            title: "Terima Kasih",
            desc: "Kami akan hubungi anda secepat mungkin",
            btn: "OK"
        },
        boost: {
            title: 'Bila Perlu Promosi?'
        },
        title: "Iklankan bersama kami",
        required: "Wajib",
        invalid: "Format Tidak Sah",
        name: "Nama",
        email: "Emel",
        contact: "Hubungi",
        product: "Produk untuk Diiklankan",
        select: "Sila pilih 1 atau lebih",
        type: {
            fashion: "Fesyen",
            car: "Pengedar Kereta",
            flower: "Kedai Bunga",
            accessory: "Aksesori",
            other: "Lain-lain"
        },
        desc: "Terangkan produk anda",
        remark: "Catatan",
        require: "Medan wajib",
        submit: "HANTAR",
        backToApp: "KEMBALI KE APLIKASI"
    },
    support: {
        title: 'Perlukan bantuan?',
        desc: 'Pasukan sokongan pelanggan kami sentiasa sedia membantu!',
        desc2: `Tinggalkan mesej & kami akan hubungi anda.`,
        name: 'Nama',
        email: 'Emel',
        issue: 'Isu',
        options: {
            feedback: 'Maklum balas',
            request: 'Permintaan Ciri',
            bug: 'Pepijat',
            others: 'Lain-lain'
        },
        details: 'Butiran',
        placehoder: 'Tulis butiran anda di sini',
        submit: "HANTAR"
    },
    aboutUs: {
        aboutUs: {
            title: 'Tentang Kami',
            desc: `Selamat datang ke {{boldText}}, destinasi utama untuk penstriman langsung dan penguasaan dunia e-sukan. Sama ada anda peminat e-bola sepak, {{boldText}} ialah platform terbaik anda untuk kandungan berkualiti tinggi dan pembangunan kemahiran yang tiada tandingan.`
        },
        platform: {
            title: 'Platform Kami',
            desc: `{{boldText}} direka untuk memenuhi permintaan yang semakin meningkat terhadap kandungan e-sukan berkualiti tinggi. Dengan fokus kepada e-bola sepak, platform kami menawarkan pelbagai ciri termasuk:`,
            point1: '{{boldText}} Tonton perlawanan masa nyata yang menampilkan pemain dan pasukan terkemuka dari seluruh dunia. Penstriman HD kami memastikan anda tidak terlepas sebarang aksi.',
            point2: `{{boldText}} Belajar daripada yang terbaik dengan tutorial eksklusif, analisis strategi dan tip profesional kami. Kandungan ini dikurasi untuk membantu pengguna meningkatkan kemahiran mereka, tidak kira pemula atau profesional.`,
            // point3: `Komuniti Interaktif: Sertai komuniti global peminat permainan yang berkongsi minat anda. Sembang langsung semasa siaran, sertai forum dan berhubung dengan peminat dan pemain lain.`
        },
        why: {
            title: 'Kenapa Pilih VECTORSPORT?',
            desc: `Sama ada anda peminat kasual atau pemain yang bercita-cita tinggi, {{boldText}} menawarkan sesuatu untuk semua orang. Daftar hari ini untuk mula menonton, belajar dan berhubung dengan komuniti e-sukan global. Bersama-sama, kita akan meningkatkan permainan anda ke tahap seterusnya.`
        },
        future: {
            title: "Perancangan Masa Depan",
            desc: `Kami teruja untuk mengumumkan bahawa {{boldText}} sedang berkembang! Selain e-bola sepak, kami akan membangunkan kandungan untuk e-bola keranjang dan permainan e-sukan popular lain. Nantikan ciri baharu dan kemas kini untuk meningkatkan pengalaman permainan anda.`
        },
        promote: {
            title: 'Promosikan Kelab Anda',
            desc: `Jika anda sebahagian daripada kelab sukan dan ingin mempromosikan aktiviti anda, {{boldText}} menyediakan platform hebat untuk mempamerkan pasukan dan acara anda. Hubungi kami untuk peluang kerjasama dan tingkatkan keterlihatan kelab anda dalam komuniti e-sukan.`
        }
    },
    err: {
        timeout: "Permintaan telah tamat masa"
    }
}

export default ms;